export default (axios, baseURL) => async (clientSid, type, attachment) => {
  const url = `/hub/clients/${encodeURIComponent(clientSid)}/csv/upload`;

  // Create FormData and append fields
  const formData = new FormData();
  formData.append('type', type);
  formData.append('attachment', attachment);

  const axiosConfig = {
    method: 'POST',
    baseURL,
    url,
    data: formData
  };

  try {
    const axiosResponse = await axios(axiosConfig);

    if (!axiosResponse || !axiosResponse.data || typeof axiosResponse.data !== 'object') {
      throw new Error('Invalid response from gateway');
    }
    return axiosResponse.data;
  } catch (error) {
    if (error.response && error.response.data) {
      return { error: error.response.data };
    }
    throw error;
  }
};
